import api from './api';

export const liquidacionService = {
  downloadReport: (investorId: string, year: number, quarter: number) => {
    return api.get(`/reports/liquidacion/${investorId}`, {
      params: { year, quarter },
      responseType: 'blob',
    });
  },

  downloadZip: (investorIds: string[], year: number, quarter: number) => {
    return api.post('/reports/liquidacion/download-zip', { investorIds, year, quarter }, {
      responseType: 'blob',
    });
  },

  sendBatchReports: (investorIds: string[], year: number, quarter: number) => {
    return api.post('/reports/liquidacion/send-batch', { investorIds, year, quarter });
  },
};
